/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint no-unused-vars: "off"*/
import React, {useEffect, useState} from 'react';
import MapBase from "./MapBase";
import {PALETTE_YlOrRd_9, TRANSPARENT_COLOR} from "../../utils/Palette";
import useMapProps from "./useMapProps";
import {MapPropsProvider} from "./MapPropsContext";
import WidgetContainer2 from "./widgets/WidgetContainer2"; // 확장된 위젯
import WidgetContainer4 from "./widgets/WidgetContainer4";
import {arrayToRgb, getLastYear, getApiUrl, makeTableSorterFn, numberWithCommas, positionToDegress} from "../../utils";

import WidgetPublicStatStation from "./widgets/WidgetPublicStatStation";
import WidgetPublicStatStationInputBox from "./widgets/WidgetPublicStatStationInputBox";
import RMateChartPublicStatStation from "./r_mate_chart/RMateChartPublicStatStation";

import WidgetLegend from "./widgets/WidgetLegend";
import Seperator from "./widgets/Seperator";
import WidgetStatisticsTable from "./widgets/WidgetStatisticsTable";
import WidgetSelectYearMonth from "./widgets/WidgetSelectYearMonth";
import WidgetRisingTabsPublicStatStation from "./widgets/WidgetRisingTabsPublicStatStation";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import WidgetToolbar from "./widgets/WidgetToolbar";
import {WELL_KNOWN_POSITION} from "../../Constants";
import AlignRightText from "./widgets/AlignRightText";


const ICON_MAPPING = {
  '32': ['cls1', '기지국'],
  '85': ['cls2', '이동중계국'],
  '94': ['cls3', '간이무선국'],
  '44': ['cls4', '육상무선국'],
  '49': ['cls5', '이동국'],
  '92': ['cls6', '아마추어국'],
  '42': ['cls7', '의무선박국'],
  '41': ['cls8', '선박국'],
  '21': ['cls9', '고정국'],
  '35': ['cls10', '육상국'],
  '11': ['cls11', '지상파방송국'],
  '12': ['cls12', '실용화시험국(방송국용)'],
  '13': ['cls13', '위성방송국'],
  '15': ['cls14', '신고제외무선국'],
  '16': ['cls15', '지상파방송보조국'],
  '17': ['cls16', '발신전용휴대전화(CT-2)'],
  '18': ['cls17', '가입자회선용무선국'],
  '19': ['cls18', '위성방송보조국'],
  '22': ['cls19', '전송망'],
  '23': ['cls20', '종합유선방송국'],
  '24': ['cls21', '중계유선방송'],
  '25': ['cls22', '음악유선방송'],
  '27': ['cls23', '개인휴대전화(PCS)'],
  '28': ['cls24', '주파수공용무선전화(자가용)'],
  '29': ['cls25', '무선조정중계국'],
  '30': ['cls26', '무선조정이동국'],
  '31': ['cls27', '해안국'],
  '33': ['cls28', '항공국'],
  '34': ['cls29', '휴대기지국'],
  '36': ['cls30', '일반해안국'],
  '37': ['cls1', '무선데이타통신'],
  '38': ['cls2', '어업용해안국'],
  '40': ['cls3', '구명부기국'],
  '43': ['cls4', '비상위치지시용무선표지국'],
  '45': ['cls5', '항공기국'],
  '46': ['cls6', '의무항공기국'],
  '47': ['cls7', '휴대국'],
  '48': ['cls8', '선상통신국'],
  '50': ['cls9', '선박국대여'],
  '51': ['cls10', '무선방향탐지국'],
  '52': ['cls11', '무선표지국'],
  '53': ['cls12', '무선항행육상국'],
  '54': ['cls13', '무선항행이동국'],
  '55': ['cls14', '무선측위국'],
  '56': ['cls15', '무선항행국'],
  '57': ['cls16', '무선탐지육상국'],
  '58': ['cls17', '무선탐지이동국'],
  '59': ['cls18', '비상위치지시용위성무선표지국'],
  '61': ['cls19', '비상국'],
  '62': ['cls20', '표준주파수및시보국'],
  '63': ['cls21', '기상원조국'],
  '64': ['cls22', '구내무선국'],
  '65': ['cls23', '주파수공용간이무선국'],
  '66': ['cls24', '차량디지틀이동전화'],
  '67': ['cls25', '휴대디지틀이동전화'],
  '68': ['cls26', '차량/휴대디지틀이동전화'],
  '69': ['cls27', '위성휴대통신용무선국'],
  '70': ['cls28', '육상지구국'],
  '71': ['cls29', '우주국'],
  '72': ['cls30', '지구국'],
  '73': ['cls1', '선박지구국'],
  '74': ['cls2', '해안지구국'],
  '75': ['cls3', '이동지구국'],
  '76': ['cls4', '육상이동지구국'],
  '77': ['cls5', '항공지구국'],
  '78': ['cls6', '항공기지구국'],
  '79': ['cls7', '기지지구국'],
  '80': ['cls8', '일반지구국'],
  '81': ['cls9', '산업용'],
  '82': ['cls10', '통신용'],
  '83': ['cls11', '의료용'],
  '84': ['cls12', '차량이동가입무선전화'],
  '86': ['cls13', '휴대이동가입무선전화'],
  '87': ['cls14', '주파수공용무선전화'],
  '88': ['cls15', '생활무선국(CB)'],
  '89': ['cls16', '차량/휴대가입무선전화'],
  '90': ['cls17', '이동품질감시'],
  '91': ['cls18', '실험국'],
  '93': ['cls19', '실용화시험국(실험국용)'],
  '95': ['cls20', '고정수신국'],
  '96': ['cls21', '무선호출국'],
  '97': ['cls22', '무선조정국'],
  '98': ['cls23', '코드레스폰'],
  '99': ['cls24', '전파천문국'],
  // 'RD': ['cls25', '레이다펄스변조송신'],
  // 'TV': ['cls26', 'TV방송국'],
};

const ICON_CODE_BY_CLS_CODE = Object.entries(ICON_MAPPING).reduce((acc, [clsCode, [iconCode]]) => {
  acc[clsCode] = iconCode;
  return acc;
}, {});

const CLS_CODE_OPTIONS = Object.entries(ICON_MAPPING).map(([clsCode, [iconCode, iconLabel]]) => {
  return { cls_code: clsCode, label: iconLabel };
});

function MapPublicStatStation() {

  const [fillColorLegend, setFillColorLegend] = useState([]);

  const mapProps = useMapProps({
    INITIAL_VIEW_STATE: {
      ...WELL_KNOWN_POSITION.세종특별자치시,
      zoom: 8,
    },
    INITIAL_GEOJSON_EXTRA_PARAMS: {
      year: getLastYear(),
      month: 12,
      currentDistrictCode: '',
    },
    INITIAL_GEOJSON_POLYGON_LAYER_PROPS: {
      getHoverHtml: (object, mapDistrictStats) => {
        const [metricObject] = mapDistrictStats;
        const {properties: {pk, name}} = object;
        const code = pk;
        const obj = metricObject[code];
        if (obj) {
          const {total} = obj;
          return `<span class='fontStyle'>${name}</span><br/> 
                   무선국 수 : ${numberWithCommas(total)}개<br/>`;
        }
        return `<span class='fontStyle'>${name}</span><br/> 
                  무선국 수 : 0개<br/>`;
      },
      getLevelFillColor: ({properties: {pk}}, mapDistrictStats) => {
        const [metricObject, metricMax] = mapDistrictStats;
        const code = pk;
        const obj = metricObject[code];
        if (obj) {
          const {total} = (metricObject[code] || {total: 1});
          if (total >= 1) {
            const index = Math.floor(PALETTE_YlOrRd_9.length * (total - 1) / metricMax);
            return PALETTE_YlOrRd_9[index];
          }
          return TRANSPARENT_COLOR;
        }
        return TRANSPARENT_COLOR;
      },
    },
    INITIAL_WIDGET_STATE: {
      //cls_code_stats_list: ["44", "94", "32"],
      cls_code_stats_list: Object.keys(ICON_MAPPING),
      display_code_stats: "01",
      //field1:"서울특별시청",
      field1:"",
      field2:"",
      field3:"",
      field4:"",
    }
  });

  const [statsJsonSearchCodeList, setStatsJsonSearchCodeList] =
    useState({
        //cls_code: ["44", "94", "32"],
        cls_code: Object.keys(ICON_MAPPING),
        //field1 : "한국방송공사사장",
        field1 : "",
        field2 : "",
        field3 : "",
        field4 : "",
      }
    );
  
  /* 서버 Ajax 통신을 위해 json을 만듭니다. */
  const settingChkRadSvcString = (checkList) => {
    // as-is 의 json 통신을 위한 문자열 만들기
    let JSONList = {
      "data": []
    };

    for (let value of checkList) {
      const jsonValue = {"CHK_VALUE": value};
      JSONList.data.push(jsonValue);
    }

    return JSON.stringify(JSONList);
  };

  const {
    widgetState,
    dataResponseList,
    mapDistrictStats, setMapDistrictStats, isChangedMapDistrictStats,
    geojsonExtraParams,
    clickedPolygonGeojsonObjects,
    setGeojsonExtraParams,
    currentDistrictCode,
    setCurrentDistrictCode,
  } = mapProps;

  const {
    cls_code_stats_list,
    //값이 변하는것 넣어놓고,
    field1,
    field2,
    field3,
    field4,
  } = widgetState;
  const [sidoCode, setSidoCode] = useState('');

  useEffect(() => {
    const {
      cls_code_stats_list,
      //값이 변하는것 넣어놓고,
      field1,
      field2,
      field3,
      field4,
    } = widgetState;
    setStatsJsonSearchCodeList(
      {
        cls_code: cls_code_stats_list,
        //값이 변하는것 넣어놓고,
        field1,
        field2,
        field3,
        field4,
      });
  }, [widgetState]);

  const {display_code_stats} = widgetState;
  
  useEffect(() => {
    // String 조합
    let searchCodeList = [];

    const cls_list = statsJsonSearchCodeList["cls_code"];

    const {
      frq_list,
      div_code_stats_list,
      sta_code_stats_list,
      cls_code_stats_list,
      //값이 변하는것 넣어놓고,
      field1,
      field2,
      field3,
      field4,
  } = widgetState;

    const codeList = searchCodeList;
    // 데이터리스트에서 맞는 문자열의 합 구하기
    const metricObject = {};
    if (dataResponseList.length > 0) {

      const firstDataLayer = dataResponseList[0];
      for (let [code, stats] of Object.entries(firstDataLayer)) {
        let total = 0;
        for (let [checkCode, stat] of Object.entries(stats)) {
          
          //CUS_NO, CUS_FLN, CLS_CODE, CLS_NAME,  
          //ASG_STD_NM, ISC_CODE, ISC_DIV_CD, ISC_TITLE, ISC_AUTH_NAME,
          //DISTRICT_LV1_CODE, DISTRICT_LV2_CODE, TOTAL
          //"198122:한국전기연구원:82:통신용:None:D0277:공운법:한국전기연구원:과학기술정보통신부": 1,
          let tmpArr = checkCode.split(':');
          
          let clsCodeVal = tmpArr[2]; // cls         
          
          let asgStdNmVal = tmpArr[4]; // ASG_STD_NM
          let iscDivCdVal = tmpArr[6]; // 대분류
          let iscTitleVal = tmpArr[7]; // 기관
          let iscAuthVal = tmpArr[8]; // 주무부처

          if (cls_list.includes(clsCodeVal)   // 체크박스의 모든 조건을 만족할 때
            //&& cls_list.includes(clsCodeVal)
            && iscDivCdVal.includes(field1)
            && iscTitleVal.includes(field2)
            && iscAuthVal.includes(field3)
            && asgStdNmVal.includes(field4)
            ) {  
              const codeVal = firstDataLayer[code][checkCode];
              total += codeVal;           
          } // 카운트 if문 끝
        }
        metricObject[code] = {total};
      }
    }

    setSidoCode((currentDistrictCode || '').length < 2
      ? ''
      : currentDistrictCode.substr(0, 2));
    
    const metricMax = Math.max(...Object.values(metricObject).map(obj => obj.total));

    const newMapDistrictStats = [metricObject, metricMax];
    if (isChangedMapDistrictStats(newMapDistrictStats)) {
      setMapDistrictStats(newMapDistrictStats);

      ////////// ajax new_param 설정////////////
      // 연월 세팅
      const {year, month} = geojsonExtraParams;

      if (month < 10) {
        window.searchYear = year.toString() + '0' + month.toString();
      } else {
        window.searchYear = year.toString() + month.toString();
      }
    }
  }, [dataResponseList, widgetState, statsJsonSearchCodeList, geojsonExtraParams, currentDistrictCode]);

  useEffect(() => {
    if (clickedPolygonGeojsonObjects.length > 0) {
      const firstLayer = clickedPolygonGeojsonObjects[0];
      const {properties: {name, pk}} = firstLayer;
      if ((pk || '').length <= 2) {
        setCurrentDistrictCode(pk);
      }
    }
  }, [clickedPolygonGeojsonObjects]);

  useEffect(() => {
    const [metricObject, metricMax] = mapDistrictStats;
    if (window.isFinite(metricMax) && metricMax >= 9) {
      setFillColorLegend(
        [...Array(9).keys()].map(colorIndex => {
          const boundary = (metricMax / 9) * (colorIndex + 1);
          const index = Math.floor(PALETTE_YlOrRd_9.length * (boundary - 1) / metricMax);
          const colorRgb = arrayToRgb(PALETTE_YlOrRd_9[index]);
          return [colorRgb, boundary];
        }).reverse()
      );
    } else { // 데이터가 없을때
      setFillColorLegend(
        [...Array(1).keys()].map(colorIndex => {
          const boundary = 0;
          const colorRgb = '#ffffd9';
          return [colorRgb, boundary];
        }).reverse()
      );
    }
  }, [mapDistrictStats]);

  useEffect(() => {
    setGeojsonExtraParams(prev => ({
      ...prev,
      currentDistrictCode,
    }));
  }, [currentDistrictCode]);

  const makeColumns = () => {
      return [
        {title: '지역', dataIndex: 'GUGUN', key: 'GUGUN', width: 340, fixed: 'left'},
        {title: '무선국 수', dataIndex: 'CNT', key: 'CNT',
          render: value => AlignRightText({ text: value, numberComma: true })},  
      ]
  };

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase isHideWidgetToggleClustering={true} isHideWidgetMapLayerTypes={true}>
        <WidgetContainer2>
          <div>
            <WidgetDistrictSelect isShowDistrictLayerFromGeoserver={true} onlyLv1={true} />
            {/*
             <WidgetSelectYearMonth/>
            <Seperator/>
             */}
             {/* {"시도코드" + sidoCode} */}
            <WidgetPublicStatStation options={CLS_CODE_OPTIONS} iconCodeByCls={ICON_CODE_BY_CLS_CODE}/>
            {/* <WidgetPublicStatStationInputBox fetchUrl={getApiUrl({type: "type3"})}/> */}
          </div>
        </WidgetContainer2>
        
        <WidgetContainer4>
          <div>
            <WidgetPublicStatStationInputBox fetchUrl={getApiUrl({type: "type3", district_code: ""})}/>
          </div>
        </WidgetContainer4> 
       
      </MapBase>
      <WidgetRisingTabsPublicStatStation titleOnInit={'지역별 무선국 수'}>
        <WidgetStatisticsTable
          fetchUrl={getApiUrl({type: "type3", district_code: ""})}
          type={"type3"}
          getTitle={(layer) => "지역별 무선국 수"}
          columns={makeColumns()}
        />

      </WidgetRisingTabsPublicStatStation>

      <RMateChartPublicStatStation 
        clsList={cls_code_stats_list}
        sidoCode={sidoCode}
        disabled={(widgetState.cls_code_stats_list.length === 0)}
      /> 
      
      {fillColorLegend.length > 0 && <WidgetLegend fillColorLegend={fillColorLegend}  titleColorLegend={'무선국 수'}  unitColorLegend={'개'}/>}
      <WidgetToolbar/>
    </MapPropsProvider>
  );
}

export default MapPublicStatStation;
